import { PhoneVerificationForm } from "./PhoneVerificationForm";

export const PhoneVerificationPage = () => {
  return <PhoneVerificationForm />;
};
